module.exports = __webpack_public_path__ + "static/media/background.abbc018e.svg";